import { render } from "./ScrollTop.vue?vue&type=template&id=160e11dc&scoped=true&ts=true"
import script from "./ScrollTop.vue?vue&type=script&lang=ts"
export * from "./ScrollTop.vue?vue&type=script&lang=ts"

import "./ScrollTop.vue?vue&type=style&index=0&id=160e11dc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160e11dc"]])

export default __exports__